import React from 'react';
import classNames from 'classnames';

import styles from './recentIdeaStyles';

import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import Link, { LINK_TYPES } from 'buyside/components/presentation/Link/link';
import Direction from 'buyside/components/presentation/Direction/direction';
import ReturnValue from 'buyside/components/presentation/ReturnValue/returnValue';
import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';

import { noop } from 'buyside/util/lodashAlt';
import LightbulbIcon from 'buyside/svgs/lightbulb.svg';

import { ideaUrl, userUrl, defaultUserImageUrl } from 'buyside/util/urlHelper';

const RecentIdea = ({
  idea,
  size = null,
  showEntityName = false,
  showReturnInfo = true,
  showExcerpt = true,
  showUserDetails,
  onIdeaLinkClick = noop,
  onUserLinkClick = noop
}) => {
  const elevatorPitchLimit = size === 'small' ? 65 : 115;
  const isSmall = size === 'small';
  return (
    <div>
      {showEntityName && (
        <div className={styles.recentIdeaHeader}>
          <LightbulbIcon className={styles.recentIdeaLightbulb} />
          <Link
            className={styles.recentIdeaEntityName}
            to={ideaUrl(idea.id)}
            type={LINK_TYPES.PLAIN}
            onMouseDown={onIdeaLinkClick}
          >
            {idea.positions.map(position => (
              <div key={position.id}>
                {position.asset.entity.name}
                <span className={styles.recentIdeaSymbol}>({position.asset.primarySymbol})</span>
              </div>
            ))}
          </Link>
        </div>
      )}
      <div className={styles.recentIdea}>
        <ProfileImage
          source={showUserDetails ? idea.user.profileImageUrl : defaultUserImageUrl()}
          size={isSmall ? 'tiny' : 'small'}
        />
        <div className={styles.recentIdeaContent}>
          <h3 className={isSmall ? styles.recentIdeaHeadingSmall : styles.recentIdeaHeading}>
            {showUserDetails ? (
              <Link
                to={showEntityName ? userUrl(idea.user.id) : ideaUrl(idea.id)}
                type={LINK_TYPES.PLAIN}
                onMouseDown={onUserLinkClick}
              >
                {idea.user.displayName}
              </Link>
            ) : (
              <AnonymousUserDisplay anonUser={{ title: '' }} />
            )}
          </h3>
          <div className={styles.detailWrap}>
            <time className={isSmall ? styles.small : ''}> Submitted {idea.postedAt} ago</time>
          </div>
          {showReturnInfo && (
            <div className={styles.detailWrap}>
              <span className={styles.directionArea}>
                {idea.positions.map(position => (
                  <Direction
                    key={position.id}
                    direction={position.direction}
                    isSmall
                    redacted={!idea.canCurrentUserViewIdeaFilterDetails}
                  />
                ))}
              </span>
              <span className={styles.returnArea}>
                <ReturnValue value={idea.totalReturn} />
              </span>
            </div>
          )}
          {showExcerpt && (
            <p
              className={classNames(styles.recentIdeaExcerpt, {
                [styles.recentIdeaExcerptSmall]: isSmall
              })}
            >
              <Link to={ideaUrl(idea.id)} type={LINK_TYPES.PLAIN} onMouseDown={onIdeaLinkClick}>
                {idea.elevatorPitch === null
                  ? ''
                  : `"${idea.elevatorPitch.substr(0, elevatorPitchLimit).trim() + '...'}"`}
              </Link>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecentIdea;
